/**
 * @generated SignedSource<<179c0f31704dfaf812e98b314ee5ed82>>
 * @relayHash ab499dd28361713eee2beb85c20f153d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1a65bcdc25b5dc1082d7d4862a7162897a2bab7a11f99ff16dad2a7128fb85a0

import type { ConcreteRequest } from 'relay-runtime';
export type useConnectorStatesQuery$variables = {
  orgId: string;
  resourceId: string;
};
export type useConnectorStatesQuery$data = {
  readonly admin_getAllDataSources: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly datasources: ReadonlyArray<{
          readonly enabled: boolean;
        }> | null;
        readonly type: string;
      } | null;
    }> | null;
  } | null;
};
export type useConnectorStatesQuery = {
  response: useConnectorStatesQuery$data;
  variables: useConnectorStatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "resourceId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
      },
      {
        "kind": "Variable",
        "name": "resourceId",
        "variableName": "resourceId"
      }
    ],
    "concreteType": "AdminConnectorConnection",
    "kind": "LinkedField",
    "name": "admin_getAllDataSources",
    "plural": false,
    "selections": [
      {
        "concreteType": "AdminConnectorEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "AdminConnector",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "type"
              },
              {
                "concreteType": "AdminDataSource",
                "kind": "LinkedField",
                "name": "datasources",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "enabled"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useConnectorStatesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useConnectorStatesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ab499dd28361713eee2beb85c20f153d",
    "id": "1a65bcdc25b5dc1082d7d4862a7162897a2bab7a11f99ff16dad2a7128fb85a0",
    "metadata": {},
    "name": "useConnectorStatesQuery",
    "operationKind": "query",
    "text": "query useConnectorStatesQuery($orgId:ID!,$resourceId:ID!){admin_getAllDataSources(orgId:$orgId,resourceId:$resourceId){edges{node{type,datasources{enabled}}}}}"
  }
};
})();

(node as any).hash = "d27aba7eacb41b0a41098a64d54e62cb";

export default node;
